import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ConfigService } from "src/app/core/config.service";
import { FinOpsAwsOnOffResourcesDayMeasures } from "./finops-aws-on-off.model";
import { DateService, HistoricalDate } from "src/app/shared/service/date.service";
import { DateGranularityEnum } from "src/app/shared/enum/date-granularity.enum";

@Injectable({
    providedIn: 'root'
})
export class FinOpsOnOffResourcesService {

    constructor(
        private httpClient: HttpClient,
        private configService: ConfigService,
        private dateService: DateService
    ) {
    }

    loadOnOffResourcesHistoricalData(date: string, granularity: DateGranularityEnum, accountId: string) {
        return this.httpClient.get<FinOpsAwsOnOffResourcesDayMeasures>(`${this.configService.config.apiUrl}/finops/aws/on_off?date=${date}&granularity=${granularity}&account=${accountId}`)
    }

    loadOnOffResourcesMeasures(date: string, accountId: string) {
        return this.httpClient.get<FinOpsAwsOnOffResourcesDayMeasures>(`${this.configService.config.apiUrl}/finops/aws/on_off/measures?date=${this.dateService.formatShortDate(date)}&account=${accountId}`)
    }
}
